import axios from 'axios';
import { BASE_URL } from '../configs';

export const fetchVouchersShopee = async (page, category) => {
  const response = await axios.get(`${BASE_URL}/api/v1/shopee/voucher-shopee/show?page=${page}&category=${category}`);
  return response.data;
};